/**
 * 乘客端 DidiJSBridge 封装
 * @author huangyiustb
 * @modify liupei
 */

import { isAndroid, isIOS, logger, invokeInTurn } from '../util'
import { callIOS } from './ios'
import { callAndroid } from './android'
import { compareAppVersion } from '../ddbridge/app'
import { bridgeReady } from '../core/bridge'
import { financeConfig } from '../config'

let DDBridgeFinance = {}

const defaultFn = function () {}

function _call(method, param, callback) {
  if (isAndroid) {
    callAndroid(method, param, callback)
  } else {
    callIOS(method, param, callback)
  }
}


function call(method, param, callback) {
  // _call(method, param, callback)
  invokeInTurn(_call, arguments)
}


/**
 * 根据config创建JSBridge方法
 * @param conf 配置文件
 * @returns {Function}
 */
function passengerBridgeFn(name, conf, isOldVersion) {
  return function (param = {}, callback = defaultFn) {

    if (arguments.length === 1 && typeof param === 'function') {
      callback = param
      param = {}
    }

    // 根据版本号区分ddbridge和echo
    // http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=75128588
    let method = name,
        isAndlite = isAndroid && compareAppVersion('>=', '5.0.0'),
        isIoslite = isIOS && compareAppVersion('>=', '5.0.0')
        

    // if (!isOldVersion && (isIoslite || isAndlite)) {
    if (true) {
      logger({
        pos: 'CALL_BRIDGE',
        version: '5.x',
        method
      })
      call(method, param, callback)
    } else {

      // if (conf && conf.fn) {
      //   method = conf.fn
      // }
      // setTimeout(() => { // hack
      //   bridgeReady((bridge) => {
      //     bridge.callHandler(method, param, data => {

      //       if (typeof data == 'string') {
      //         data = JSON.parse(data)
      //       }

      //       callback(null, data)
      //     })
      //   })
      // }, 0)

      // logger({
      //   pos: 'callBridge',
      //   version: '4.x',
      //   method
      // })
    }

  }
}

/**
 * 滴滴金融端基础的Bridge.call(method, param, callback)方法
 * @param DDBridge
 */
function initFinanceBaseCall(DDBridge) {
  // isOldVersion 强制使用老版本ddbridge
  DDBridge.call = function (method, param, callback, isOldVersion) {
    let conf = financeConfig[method],
        bridgeFn = passengerBridgeFn(method, conf, isOldVersion)

    if (!callback && typeof param === 'function') {
      callback = param
      param = {}
    }
    return bridgeFn(param, callback)
  }
  return DDBridge
}

initFinanceBaseCall(DDBridgeFinance)

export { DDBridgeFinance }



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgefinance/index.js